{
  "Earlier": "更早",
  "newNotification": "{newCount} 个新通知",
  "newNotifications": "{newCount} 个新通知",
  "noNotifications": "您将收到有关我们产品、与其他用户的合作以及其他相关更新的重要信息。",
  "noNotificationsTitle": "将在此处显示您的通知"
}
